const PROFILE_ROUTES = {
  ONBOARD_NAME: "onboard-name",
  DATE_OF_BIRTH: "date-of-birth",
  ONBOARD_GENDER: "onboard-gender",
  DATE_PREFERENCE: "date-preference",
  ONBOARD_FINDOUT: "onboard-findout",
  ONBOARD_UPLOAD: "onboard_upload",
  SELECT_EXPERIENCE: "select-experience",
  ONBOARD_GRANTACCESS: "grant-access",
  ONBOARD_LOCATION: "onboard-location",
  ONBOARD_SUBSCRIBE: "onboard-subscribe",
  ONBOARD_ALLDONE: "onboar-alldone",
  BASIC_INFO: "basic-info",
  MORE_DETAILS: "more-details",
  COMPANY_ADD:"company-add",
  CITY_ADD:"city-add",
  USE_REASON:"use-reason",
  SOCIAL_LINK_ADD:"social-link-add"
};

export { PROFILE_ROUTES };
